export function formatScore(score: number) {
  if (score < 0 || score > 90) {
    return 0;
  }
  if (score <= 30) {
    return 3;
  }
  if (score <= 60) {
    return 2;
  }
  return 1;
}
